import { useMutation } from 'react-query'

import { APIError, APIResponse } from '../../../utils'
import { createAddress } from '../query-api'
import { ShippingAddress } from '../types/shippingAddress'

interface UseCreateAddressProps {
  onError?: (error?: APIError) => void
  onSuccess?: (data: APIResponse<ShippingAddress>, variables: Partial<ShippingAddress>) => void
}

export const useCreateAddress = (props?: UseCreateAddressProps) => {
  const { onError, onSuccess } = props || {}
  const {
    mutate: create,
    mutateAsync: createAsync,
    isLoading: isProcessing,
    ...rest
  } = useMutation(createAddress, {
    onSuccess,
    onError,
  })

  return { create, createAsync, isProcessing, ...rest }
}
